// extracted by mini-css-extract-plugin
export default {"root":"UserIcon_root__82a0R"};